module.exports = __webpack_public_path__ + "static/media/search.7cf225a8.svg";